function getAdminProfile () {
    return window.Vue.$httpCookiesOnly.post(`${process.env.VUE_APP_UPFYGATE}/automation/api/profile/version/1.0/find-by-intranet`,
    {
        config: {
            intranet_id: window.Vue.$store.state.auth.assinaturaId
        }
    })
    .then(resp => {
        if (resp.data.status.toLowerCase() === 'ok') {
            return Promise.resolve(resp.data.data)
        }

        return Promise.reject(resp.data)
    })
    .catch(err => {
        return Promise.reject(err.response.data)
    })
}

function getUserProfile () {
    return window.Vue.$httpCookiesOnly.post(`${process.env.VUE_APP_UPFYGATE}/automation/api/profile/version/1.0/find-by-user`,
    {
        config: {
            intranet_id: window.Vue.$store.state.auth.assinaturaId,
            user_id: window.Vue.$store.state.auth.usuarioId
        }
    })
    .then(resp => {
        if (resp.data.status.toLowerCase() === 'ok') {
            let respAsArray = [resp.data.data]
            return Promise.resolve(respAsArray)
        } else {
            return Promise.reject(resp.data)
        }
    })
    .catch(err => {
        return Promise.reject(err.response.data)
    })
}

function getProfilesList () {
    if (!window.Vue.$store.state.auth.acessoConfigurarLoginsTodos) {
        return getUserProfile().then(resp => {
            return Promise.resolve(resp)
        }).catch(err => {
            return Promise.reject(err)
        })
    }

    return window.Vue.$httpCookiesOnly.post(`${process.env.VUE_APP_UPFYGATE}/automation/api/profile/version/1.0/list-by-intranet`,
    {
        config: {
            intranet_id: window.Vue.$store.state.auth.assinaturaId
        }
    })
    .then(resp => {
        if (resp.data.status.toLowerCase() === 'ok') {
            return Promise.resolve(resp.data.profiles)
        } else {
            return Promise.reject(resp.data)
        }
    })
    .catch(err => {
        return Promise.reject(err.response.data)
    })
}

function getPreSignedUrl (filePath) {
    return window.Vue.$httpCookiesOnly.post(`${process.env.VUE_APP_UPFYGATE}/automation/api/document/version/1.0/bucket_presigned_url`,
    {
        config: {
            object_key: filePath
        }
    })
    .then(resp => {
        if (resp.data.status.toLowerCase() === 'ok') {
            return Promise.resolve(resp.data.data)
        } else {
            return Promise.reject(resp.data)
        }
    })
}

export {
    getProfilesList,
    getAdminProfile,
    getPreSignedUrl
}
